import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 md:gap-20">
          <div className="md:col-span-6">
            <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-5">04 · Contact</div>
            <h2 className="font-display text-4xl md:text-6xl font-light tracking-tighter leading-[1.02]">
              Parlons<br />
              de votre projet.
            </h2>
            <p className="mt-8 text-lg text-neutral-600 max-w-md leading-relaxed">
              Le <span className="text-black font-semibold">devis est gratuit</span> et
              sans engagement. Remplissez le questionnaire en 2 minutes ou contactez-nous
              directement.
            </p>

            <Link
              to="/devis"
              data-testid="contact-cta-devis"
              className="mt-10 btn-red inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm font-semibold"
            >
              Démarrer mon devis gratuit
            </Link>
          </div>

          <div className="md:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <a
              href="tel:0753221529"
              data-testid="contact-phone"
              className="group p-8 bg-[#FAFAFA] border border-black/10 rounded-2xl hover:bg-black hover:text-white transition-colors duration-300"
            >
              <Phone size={20} strokeWidth={1.5} className="mb-6 text-[#FF2800] group-hover:text-[#FFB800] transition" />
              <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 group-hover:text-neutral-300 mb-2">Téléphone</div>
              <div className="font-display text-2xl font-medium tracking-tight">07 53 22 15 29</div>
            </a>

            <a
              href="mailto:depannagexpress67@gmail.com"
              data-testid="contact-email"
              className="group p-8 bg-[#FAFAFA] border border-black/10 rounded-2xl hover:bg-black hover:text-white transition-colors duration-300"
            >
              <Mail size={20} strokeWidth={1.5} className="mb-6 text-[#FF2800] group-hover:text-[#FFB800] transition" />
              <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 group-hover:text-neutral-300 mb-2">Email</div>
              <div className="font-display text-base font-medium tracking-tight break-all">depannagexpress67@gmail.com</div>
            </a>

            <div className="p-8 bg-[#FAFAFA] border border-black/10 rounded-2xl">
              <Clock size={20} strokeWidth={1.5} className="mb-6 text-[#FFB800]" />
              <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-2">Disponibilité</div>
              <div className="font-display text-xl font-medium tracking-tight">7j/7 · 8h — 20h</div>
              <div className="text-sm text-neutral-500 mt-1">Réponse rapide garantie</div>
            </div>

            <div className="p-8 bg-[#FAFAFA] border border-black/10 rounded-2xl">
              <MapPin size={20} strokeWidth={1.5} className="mb-6 text-[#FFB800]" />
              <div className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-2">Zone</div>
              <div className="font-display text-xl font-medium tracking-tight">Grand Est · Europe</div>
              <div className="text-sm text-neutral-500 mt-1">Basé à Strasbourg</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
